module.exports = __webpack_public_path__ + "static/BannerDoorStep2x-753ea18b0d7e078931b7d1ebdf570eae.jpg";